import { useState, useLayoutEffect, useRef, useEffect } from 'react';
import styles from '../styles/body.module.scss';
import btnStyles from '../styles/buttons.module.scss';
import Button from '@mui/material/Button';
import axios from '../api/axios';
import useAxiosFunction from '../hooks/useAxiosFunction';
import { Box, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserLocation } from '../utils/geolocation'; // ✅ Import geolocation util

export default function SitePage({ siteId, setSiteId, siteName, setSiteName, userId, setUserId,
  geolocation, setGeolocation
 }) {
  const navigate = useNavigate();
  const [response, error, loading, axiosFetch] = useAxiosFunction();

  const [userIdError, setUserIdError] = useState(false);
  const [userIdText, setUserIdText] = useState('');

  const [result, setResult] = useState(false);
  const [checkResult, setCheckResult] = useState(false);

  const [geoCheckPassed, setGeoCheckPassed] = useState(null);
  const [geoError, setGeoError] = useState('');

  const inputRef = useRef();
  const params = useParams();


  useEffect(() => {
    if ((siteId == null) || (siteId == 0) || (siteId != params.id)) {
      setSiteId(params.id);
      localStorage.setItem("site_id", params.id);
    }
  }, [params.id, siteId, setSiteId]);

  const handleUserIDChange = (newValue) => {
    setUserId(newValue);
  };

  useLayoutEffect(() => {
    populateSiteName();
  }, [siteId]);

  useLayoutEffect(() => {
    populateAction();
  }, [result]);

  useLayoutEffect(() => {
    checkAction();
    return () => {
      setCheckResult(false);
    };
  }, [checkResult]);

  const populateSiteName = async () => {
    if ((siteId == null) || (siteId == 0) || (siteId != params.id)) {
      setSiteId(params.id);
      return;
    }

    const bodyObj = JSON.stringify({
      id: siteId
    });

    try {
      await axiosFetch({
        axiosInstance: axios,
        method: 'post',
        url: '/getSiteName',
        requestConfig: {
          headers: {
            'Content-Type': 'application/json',
          },
          data: bodyObj
        }
      });
    } catch (err) {
      console.log(err);
    }

    setResult(true);
  };

  const populateAction = async () => {
    if (response.statusCodeValue === 200) {
      setSiteName(response.body.siteName);

      const siteLocationString = response.body.siteCoordinates; // [lng, lat]
      // Parse string into an array
      const siteCoords = JSON.parse(siteLocationString);
      const siteLat = siteCoords[1];
      const siteLng = siteCoords[0];

      try {
        const userLocation = await getUserLocation();
        const distance = haversine(userLocation.latitude, userLocation.longitude, siteLat, siteLng);

        const allowed = distance <= 402.335;  // quarter mile in meters
        //const allowed = distance <= 3705000;  // TESTING

        setGeoCheckPassed(allowed);
        setGeolocation(true);
        if (!allowed) {
          setGeoError('Based on your geolocation, you are not within range of this site so you cannot sign in or out. You will need to be nearer to the site in order to use Luddon Attendance.');
        }
        
      } catch (err) {
        setGeolocation(false);
      }
    }
  };

  const checkAction = () => {
    if (response.status === 200) {
      let res = response.userSiteStatus;

      if (res === false) {
        setUserIdText('This induction code cannot be found on this site. Make sure you are joined to the site.');
        setUserIdError(true);
      } else {
        setUserIdText('');
        setUserIdError(false);
        navigate("/user");
      }
    }
  };

  const nextPage = async (e) => {
    if (userId !== "" && userId !== 0 && userId !== null) {
      try {
        await axiosFetch({
          axiosInstance: axios,
          method: 'post',
          url: '/checkUserSiteStatus',
          requestConfig: {
            headers: {
              'Content-Type': 'application/json',
            },
            data: {
              siteId: siteId,
              id: userId
            }
          }
        });
      } catch (err) {
        console.log(err);
      }

      setCheckResult(true);
    } else {
      inputRef.current.focus();
      setUserIdText('Please provide your Luddon OnSite induction code');
      setUserIdError(true);
    }
  };

  // Haversine formula to calculate distance
  const haversine = (lat1, lon1, lat2, lon2) => {

    const R = 6371000; // meters
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const toRad = (value) => (value * Math.PI) / 180;

  return (
    <div>
      <Box className={styles.titleH1Top}>
        <h1 style={{ fontWeight: 'bold' }}>Welcome to {siteName ? siteName : 'Site Name'}</h1>
      </Box>
            {geoCheckPassed === false && (
        <Box className={styles.geoWarning}>
          <p fullWidth margin="normal" className={styles.field} style={{ color: 'red', fontWeight: 'bold' }}>{geoError}</p>
        </Box>
      )}
      <Box className={styles.questionH1}>
        <h1>Luddon OnSite Induction Code</h1>
      </Box>



      <Box className={styles.textField}>
        <FormControl fullWidth margin="normal" className={styles.field} error={userIdError}>
          <TextField
            error={userIdError}
            inputRef={inputRef}
            autoComplete='off'
            fullWidth
            id="outlined-basic"
            label="Induction Code"
            variant="outlined"
            onChange={e => handleUserIDChange(e.target.value)}
          />
          <FormHelperText>{userIdText}</FormHelperText>
        </FormControl>
      </Box>

      <Box className={btnStyles.buttonContainer}>
        <Button
          className={btnStyles.btn}
          size="large"
          variant="contained"
          disabled={geoCheckPassed === false}
          onClick={() => nextPage("SignInOut")}
        >
          Sign In/Out
        </Button>
      </Box>
    </div>
  );
}
